import { useSelector } from 'react-redux';

import { getIsReOpsUser } from 'entities/User';
import { getUserCanSeeSavingsInsights } from 'entities/User/model/selectors/userPermissionsSeletors';
import { useReportVisible } from 'shared/lib/hooks/useReportVisible';

export const useSavingsSummaryReportVisible = (): boolean | undefined => {
    const canSee = useSelector(getUserCanSeeSavingsInsights);
    const isReOpsUser = useSelector(getIsReOpsUser);

    return useReportVisible({
        flagKey: 'report_savings_enabled',
        canSee,
        isReOpsUser,
    });
};
